var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCdFGrisAjouterStructure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3,4.5h4.6v2.3H6.3c-1.9,0-3.4,1.5-3.4,3.5c0,1.9,1.5,3.4,3.4,3.4h4.6V16H6.3c-3.2,0-5.8-2.6-5.8-5.8S3.1,4.5,6.3,4.5  M17.8,4.5c3.2,0,5.7,2.6,5.8,5.8h-2.3c0-1.9-1.5-3.4-3.5-3.4h-4.6V4.5L17.8,4.5 M7.4,9.1h9.2v2.3H7.4V9.1 M17.8,10.3H20v3.4h3.5V16 H20v3.5h-2.3V16h-3.4v-2.3h3.4V10.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdFGrisAjouterStructure);
export default __webpack_public_path__ + "static/media/CdF_gris_ajouter-structure.217e22b3.svg";
export { ForwardRef as ReactComponent };